module.exports = __webpack_public_path__ + "media/images/official/special_exchange_03-6388c6cdda81d28150007a2a694c7202.png";